import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

export default function ServiceErrorWindow() {
  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ p: 2, bgcolor: grey[200], borderRadius: 1 }}>
        <Typography fontSize={14}>We encountered an unexpected error while loading this service. We apologize for the inconvenience! Please try refreshing the page. If the issue persists, you can find more information and contact our support team at support@vnetwork.vn</Typography>
      </Box>
    </Box>
  )
}